<app-user-dashboard [userMenuActiveItemIndex]="0">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbMenuItems" [home]="breadcrumbHome"></p-breadcrumb>
  <app-verify-pallets-component [isClosedSale]="false" [dto]="dto" [exportOfferId]="exportOfferId" *ngIf="dto"></app-verify-pallets-component>
</app-user-dashboard>
